export const PRINT_TABLE_CLASS = 'w-full border-collapse text-xs';

export const PRINT_CELL_CLASS = 'border border-foreground px-1.5 py-0.5 align-top';
